import { Component, OnInit } from '@angular/core';
import { BaseService } from '../../base.service';

@Component({
  selector: 'app-error-404',
  templateUrl: './error-404.component.html',
  styleUrls: []
})
export class Error404Component implements OnInit {

  title_component: string;
  title_panel: string;
  message_404: string;

  constructor(private baseService: BaseService) { }

  ngOnInit(): any {
    this.title_component = 'Page Not Found';
    this.baseService.changedComponentName(this.title_component);
    this.title_panel = 'Page Not Found';

    if (localStorage.getItem('message_404') && localStorage.getItem('message_404')  !== '') {
      this.message_404 = localStorage.getItem('message_404');
    } else {
      this.message_404 = '';
    }
  }
}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/error-404/error-404.component.ts